module.exports = __webpack_public_path__ + "img/cerise_1375.3169e5b1.jpg";